import { hexToRgb, Stack, styled, Theme } from '@mui/material';
import { replaceRgbWithRgba } from '../utils/hexToRGBA';

export const columnStyles = (theme: Theme) => ({
  backgroundColor: replaceRgbWithRgba(hexToRgb(theme.palette.primary.main)),
  borderRadius: '8px',
});

export const StyledColumn = styled(Stack)(({ theme }) => columnStyles(theme));
